import React from "react";
import { Image, Text, View } from "react-native";
import { AppImages } from "../utility/AppImages";
import { AppColors } from "../utility/AppColors";
import { AppFontStyle } from "../styles/AppFontStyle";
import { useTooltips } from "../context/WalkthroughContext";
import ChatWalkthrough from "../Components/walk-through-common-components/homeScreenTooltips/ChatWalkthrough";
import { NotificationBadge } from "../Components/NotificationBadge";
import { useNotificationCount } from "../hooks/useNotificationCount";

const CustomChatFooterDrawer = ({ focused }) => {
  const { homeWalkThroughVisible } = useTooltips();
  const { chatCount } = useNotificationCount();
  const iconColor = focused ? AppColors.buttonRed_DC2626 : "#FFFFFF";
  const textColor = focused ? AppColors.buttonRed_DC2626 : "#FFFFFF";

  return homeWalkThroughVisible ? (
    <ChatWalkthrough
      content={
        <View
          style={{
            paddingVertical: 5,
            gap: 5,
            alignItems: "center",
            position: "relative",
          }}
        >
          <View style={{ position: "relative" }}>
            <Image
              source={AppImages.icChat}
              style={{
                width: 27,
                height: 27,
                resizeMode: "contain",
                tintColor: iconColor,
              }}
            />
            <NotificationBadge
              count={chatCount}
              size="small"
              position="topRight"
              isVisible={chatCount > 0}
            />
          </View>
          <Text style={[AppFontStyle.BOLD_ANYBODY_12, { color: textColor }]}>Chat</Text>
        </View>
      }
    />
  ) : (
    <View
      style={{
        padding: 10,
        gap: 5,
        alignItems: "center",
        position: "relative",
      }}
    >
      <View style={{ position: "relative" }}>
        <Image
          source={AppImages.icChat}
          style={{
            width: 27,
            height: 27,
            resizeMode: "contain",
            tintColor: iconColor,
          }}
        />
        <NotificationBadge
          count={chatCount}
          size="small"
          position="topRight"
          isVisible={chatCount > 0}
        />
      </View>
      <Text style={[AppFontStyle.BOLD_ANYBODY_12, { color: textColor }]}>Chat</Text>
    </View>
  );
};

export default CustomChatFooterDrawer;
